export class ResendOrderConfirmationEmail
{
    public orderID: number;
}
